export const ProviderNames = {
  ALL_INDEPENDENT: 'All & Independent',
  NETJETS: 'NetJets',
  WHEELS_UP: 'WheelsUp',
  FLEXJET: 'FlexJet',
  OTHER: 'Other',
} as const;

const providerMap: Record<string, string> = {
  allindependent: ProviderNames.ALL_INDEPENDENT,
  netjets: ProviderNames.NETJETS,
  wheelsup: ProviderNames.WHEELS_UP,
  flexjet: ProviderNames.FLEXJET,
  other: ProviderNames.OTHER,
};

export function normalizeProvider(provider: string): string {
  if (!provider) {
    return provider;
  }
  const key = provider.toLowerCase().replace(/[^a-z]/g, '');
  return providerMap[key] || provider;
}
